<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";

export default {
  name: "AuditorAuditHistory",
  components: {AppLoading},
  data() {
    return {
      type : 'sms',
      loading : true,
      sort_direction : null
    }
  },
  mounted(){
    this.getReportStatus()
  },
  methods : {
    ...mapActions([
      'getReportStatus',
      'getAuditorAuditHistory'
    ]),
    setTypeTo(type) {
      this.type = type;
      localStorage.setItem('type', type);
      this.sort_direction = null;
      this.requestHistory()
    },
    async viewAuditRecord(data) {
      const route= this.$router.resolve(
        {
          name: 'AppointmentDetails',
          params: {
            id: data.auditable_id,
            vessel_id : data.auditable.vessel.id,
            type : this.type
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async requestHistory() {
      this.loading = true;
      const params = {
        auditor_id : this.$route.params.id,
        sort_direction: this.sort_direction
      };
      await this.getAuditorAuditHistory(params);
      this.loading = false;
    },
    isOverDueStatusNotClosed(data){
      const now = new Date()
      const dueDate = new Date(data?.audit_report?.ca_done_later_than?.human)
      const reportStatusClosed = this.selectedReportStatusKey['closed']?.id || 3

      return ((now > dueDate) && !(data?.report_status_id === reportStatusClosed)) ||
        (
          data?.audit_report?.ca_implemented_master_signature === null ||
          data?.audit_report?.ca_implemented_master === null ||
          data?.audit_report?.ca_implemented_date?.human === null
        )
    },
    async sortRows(column = 'status') {
      if (this.loading === true || this.tableData.length < 2) {
        return;
      }
      if (column === 'status') {
        if (this.sort_direction === null) {
          this.sort_direction = 'asc';
        } else if (this.sort_direction === 'asc') {
          this.sort_direction = 'desc';
        } else {
          this.sort_direction = null;
        }
      }
      await this.requestHistory();
    }
  },
  destroyed() {
    localStorage.removeItem('type');
  },
  async created() {
    const currentType = localStorage.getItem('type');
    if (currentType) {
      this.type = currentType;
    } else {
      localStorage.setItem('type', 'sms');
    }
    await this.requestHistory();
  },
  computed: {
    ...mapGetters([
      'reportStatusKeys',
      'auditor_audit_history'
    ]),
    selectedReportStatusKey(){
      return this.reportStatusKeys.reduce((acc, item) => {
        acc[item.code] = item;
        return acc;
      }, {});
    },
    tableData() {
      return this.auditor_audit_history[this.type] ?? [];
    }
  }
}
</script>

<template>
  <div>
    <nav class="nav nav-pills nav-justified flex-fill">
      <a :class="['gray nav-item nav-link', {'active_custom': type === 'sms'}]" href="javascript:void(0);" @click="setTypeTo('sms')">SMS</a>
      <a :class="['gray nav-item nav-link', {'active_custom': type === 'isps'}]" href="javascript:void(0);" @click="setTypeTo('isps')">ISPS</a>
      <a :class="['gray nav-item nav-link', {'active_custom': type === 'cyber'}]" href="javascript:void(0);" @click="setTypeTo('cyber')">Cyber</a>
    </nav>
    <hr>

    <div style="max-height: 60vh; overflow-y: auto;">
      <table class="table table-sm table-bordered text-center">
        <thead>
        <tr>
          <th class="text-uppercase" style="width: 30px">#</th>
          <th class="text-uppercase" style="width: 23%">Vessel</th>
          <th class="text-uppercase" style="width: 20%">Report Number</th>
          <th class="text-uppercase">Lead Auditor</th>
          <th class="text-uppercase">Date of Audit</th>
          <th class="text-uppercase">Cor Due Date</th>
          <th class="text-uppercase cursor-pointer no-select"
              @click="sortRows('status')"
          >
            Status
            <template v-if="tableData.length > 1">
              <span style="cursor: pointer" class="h6 ml-2">
              <font-awesome-icon icon="arrow-up" v-if="sort_direction === 'asc'" class="sort-arrow-up"/>
              <font-awesome-icon icon="arrow-down" v-else-if="sort_direction === 'desc'" class="sort-arrow-down"/>
              <font-awesome-icon icon="sort" v-else/>
            </span>
            </template>

          </th>
          <th class="text-uppercase">Action</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="loading">
          <tr>
            <td colspan="100%">
              <app-loading/>
            </td>
          </tr>
        </template>
        <template v-else>
          <template v-if="tableData.length === 0">
            <tr>
              <td colspan="100%" class="bg-secondary text-white">NO AUDIT RECORD FOUND</td>
            </tr>
          </template>
          <tr @dblclick="viewAuditRecord(data)" class="list-data" v-for="(data, index) in tableData">
            <td>{{ index + 1 }}</td>
            <td> {{ data?.auditable?.vessel?.name }} </td>
            <td> {{ data?.report_number }} </td>
            <td> {{ data?.pivot?.is_lead === 1 ? 'YES' : 'NO' }} </td>
            <td>
              {{ data.audit_date_start.human === data.audit_date_end.human ? data.audit_date_end.human : data.audit_date_start.human + ' - ' + data.audit_date_end.human }}
            </td>
            <td :class="[{'text-danger': isOverDueStatusNotClosed(data)}]">
              {{ data?.audit_report?.has_ncr_obs === 1? data?.audit_report?.ca_done_later_than?.human:'' }}
            </td>
            <td class="text-uppercase align-middle" v-if="data?.report_status.code === 'new'" :class="['bg-' + data?.report_status.color]">
              APPOINTED
            </td>
            <td class="text-uppercase align-middle" v-else-if="data?.report_status.code === 'open'" :class="['bg-' + data?.report_status.color]">
              IN PROGRESS
            </td>
            <td class="text-uppercase align-middle" v-else :class="['bg-' + data?.report_status.color]">
              {{ data?.report_status?.name }}
            </td>
            <td>
              <button class="e-btn e-btn-blue e-btn-sm e-text-white"
                      @click="viewAuditRecord(data)"
              >
                <font-awesome-icon icon="eye" />
                View
              </button>
            </td>
          </tr>
        </template>

        </tbody>
      </table>

    </div>
     </div>
</template>

<style scoped>
.nav > li {
  margin: .5rem 0;
  padding: .5rem;
  border-radius: 5px;

  &:hover, &:hover * {
    background-color: white;
    color: #d3313c;
  }
}

.e-btn-grp > li {
  list-style: none;
  font-size: 13px;
  padding: 4px;
  border-radius: 3px;
  color: #d3313c;
  cursor: pointer;

  &:hover {
    background-color: #fbeaec;
  }

  * {
    color: #d3313c;
  }
}

.nav-link {
  border: 1px solid gray;
}


.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;

  * {
    color: #d3313c;
  }
}

.active_custom {
  background-color: #d3313c;
  color: #fff !important;
}

.gray {
  color: #435464
}


</style>
